import { render, staticRenderFns } from "./Users-Subscription-History-List.vue?vue&type=template&id=15470c2c&scoped=true&"
import script from "./Users-Subscription-History-List.vue?vue&type=script&lang=js&"
export * from "./Users-Subscription-History-List.vue?vue&type=script&lang=js&"
import style0 from "./Users-Subscription-History-List.vue?vue&type=style&index=0&id=15470c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15470c2c",
  null
  
)

export default component.exports